import { Button } from "@/components/ui/button";
import { Mail, Copy } from "lucide-react";

interface EmailOptionsViewProps {
  supportEmail: string;
  onBack: () => void;
  onCopyEmail: () => void;
  onOpenMailApp: () => void;
}

export const EmailOptionsView = ({
  supportEmail,
  onBack,
  onCopyEmail,
  onOpenMailApp,
}: EmailOptionsViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-lg">Contact Support</h3>
        <Button variant="ghost" size="sm" onClick={onBack}>
          Back
        </Button>
      </div>
      <div className="p-3 bg-muted rounded-lg flex items-center justify-between">
        <span className="text-sm font-medium">{supportEmail}</span>
        <Button
          variant="ghost"
          size="icon"
          onClick={onCopyEmail}
          className="h-8 w-8"
        >
          <Copy className="h-4 w-4" />
        </Button>
      </div>
      <Button className="w-full" onClick={onOpenMailApp}>
        <Mail className="mr-2 h-4 w-4" />
        Open Mail App
      </Button>
    </div>
  );
};